export default __webpack_public_path__ + "static/media/webvanity.38876b48.png";